const ccgUnits = [
	{
		name: 'ATENDIMENTO PRESENCIAL PORTO ALEGRE',
		unitName: 'CLINICA MAIS',
		uf: 'RS',
		estate: 'RIO GRANDE DO SUL',
		city: 'PORTO ALEGRE',
		zipCode: '90030-142',
		address: 'AV. ALBERTO BINS, 509 - CENTRO HISTÓRICO',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
];

const clinipamUnits = [
	{
		name: 'ATENDIMENTO PRESENCIAL CURITIBA',
		unitName: 'MATRIZ CENTRO',
		uf: 'PR',
		estate: 'PARANA',
		city: 'CURITIBA',
		zipCode: '80010-150',
		address: 'RUA MONSENHOR CELSO, 98, 7º ANDAR',
		workHours: ['Segunda à Quinta 08:00 às 17:30', 'Sexta 08:00 às 16:30'],
	},
];

const gndiminasUnits = [
	{
		name: 'ATENDIMENTO PRESENCIAL ALFENAS',
		unitName: 'AUT - ALFENAS',
		uf: 'MG',
		estate: 'MINAS GERAIS',
		city: 'ALFENAS',
		zipCode: '37133-613',
		address: 'RUA ADOLFO ENGEL, 19, BLOCO II, JARDIM TROPICAL',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL POÇOS DE CALDAS',
		unitName: 'AUT - P. CALDAS',
		uf: 'MG',
		estate: 'MINAS GERAIS',
		city: 'POÇOS DE CALDAS',
		zipCode: '37700-486',
		address: 'RUA FREI CRISTOVAO FIGUEREIDO, 125 - JARDIM ESMERALDA',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL DIVINOPOLIS',
		unitName: 'AUT - DIVINIPOLIS',
		uf: 'MG',
		estate: 'MINAS GERAIS',
		city: 'DIVINOPOLIS',
		zipCode: '35500-009',
		address: 'RUA RIO DE JANEIRO, 101 - CENTRO (DENTRO DO LABORATÓRIO)',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
];

const gndiUnits = [
	{
		name: 'ATENDIMENTO PRESENCIAL RIO DE JANEIRO',
		unitName: 'AUT - CENTRO RIO DE JANEIRO',
		uf: 'RJ',
		estate: 'RIO DE JANEIRO',
		city: 'RIO DE JANEIRO',
		zipCode: '20021-280',
		address: 'R. DO PASSEIO, 30 - CENTRO',
		workHours: ['Segunda à Quinta 08:00 às 17:30', 'Sexta 08:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL AV PAULISTA SP',
		unitName: 'AUT - AV PAULISTA SP',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'SÃO PAULO',
		zipCode: '01311-914',
		address: 'AV. PAULISTA, 777 - BELA VISTA',
		workHours: ['Segunda à Quinta 08:00 às 17:30', 'Sexta 08:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL AMERICANA SP',
		unitName: 'AUT AMERICANA SP',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'AMERICANA',
		zipCode: '13465-770',
		address: 'AV. BRASIL, 1530 - VILA FREZZARIN',
		workHours: ['Segunda à Sexta 08:00 às 16:00'],
	},
];

const hapUnits = [
	{
		name: 'ATENDIMENTO PRESENCIAL MACEIO',
		unitName: 'MACEIO',
		uf: 'AL',
		estate: 'ALAGOAS',
		city: 'MACEIO',
		zipCode: '57051-150',
		address: 'RUA COMENDADOR PALMEIRA , 623 - FAROL',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL JOAO PESSOA',
		unitName: 'JOÃO PESSOA',
		uf: 'PB',
		estate: 'PARAIBA',
		city: 'JOAO PESSOA',
		zipCode: '58040-040',
		address: 'AV. JULIA FREIRE , 1058 - EXPEDICIONARIOS',
		workHours: ['Segunda à Quinta 08:00 às 18:00', 'Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL CAMPINA GRANDE',
		unitName: 'CAMPINA GRANDE',
		uf: 'PB',
		estate: 'PARAIBA',
		city: 'CAMPINA GRANDE',
		zipCode: '58400-258',
		address: 'RUA DR. SEVERINO CRUZ , 265 - CENTRO',
		workHours: ['Segunda à Quinta 08:00 às 18:00', 'Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL RECIFE',
		unitName: 'SILVA RAMOS',
		uf: 'PE',
		estate: 'PERNAMBUCO',
		city: 'RECIFE',
		zipCode: '50070-100',
		address: 'RUA SILVA RAMOS, 19 - BOA VISTA',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL NATAL',
		unitName: 'ALECRIM',
		uf: 'RN',
		estate: 'RIO GRANDE DO NORTE',
		city: 'NATAL',
		zipCode: '59031-150',
		address: 'AV. PRESIDENTE QUARESMA, 967 - ALECRIM',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL MOSSORÓ',
		unitName: 'MOSSORO',
		uf: 'RN',
		estate: 'RIO GRANDE DO NORTE',
		city: 'MOSSORO',
		zipCode: '59603-200',
		address: 'AV. DIOCESANA, 260 - NOVA BETANIA',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL CAMAÇARI',
		unitName: 'CAMAÇARI',
		uf: 'BA',
		estate: 'BAHIA',
		city: 'CAMAÇARI',
		zipCode: '42807-380',
		address: 'AV. DR. MANOEL MERCÊS, S/N - MANGUEIRAL',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL SALVADOR',
		unitName: 'TANCREDO NEVES',
		uf: 'BA',
		estate: 'BAHIA',
		city: 'SALVADOR',
		zipCode: '41820-774',
		address: 'R. FREDERICO SIMÕES, 98 - CAMINHO DAS ARVORES',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL FEIRA DE SANTANA',
		unitName: 'FEIRA DE SANTANA',
		uf: 'BA',
		estate: 'BAHIA',
		city: 'FEIRA DE SANTANA',
		zipCode: '44002-175',
		address: 'R. VISC. DO RIO BRANCO, 555 - CENTRO',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL ARACAJU',
		unitName: 'ARACAJU - SÃO JOSE',
		uf: 'SE',
		estate: 'SERGIPE',
		city: 'ARACAJU',
		zipCode: '49015-220',
		address: 'AV. GONÇALO PRADO ROLEMBERG, 1813 SÃO JOSÉ',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL BAURU',
		unitName: 'BAURU - NACOES UNIDAS',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'BAURU',
		zipCode: '17013-035',
		address: 'AVENIDA NAÇÕES UNIDAS, 1727 - VILA SANTO ANTONIO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL RIBEIRAO PRETO',
		unitName: 'RIBEIRAO PRETO',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'RIBEIRAO PRETO',
		zipCode: '14020-260',
		address: 'AVENIDA PRESIDENTE VARGAS, 367 - JD. SÃO LUIS',
		workHours: ['Segunda à Sexta 07:30 às 17:00'],
	},
	{
		name: '616 L.F CLINICA SERRANA',
		unitName: 'CLINICA SERRANA(USINA)',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'SERRANA',
		zipCode: '14150-000',
		address: 'RUA PARTICULAR, Nº 2 - CENTRO',
		workHours: ['Segunda à Quinta 07:00 às 19:00', 'Sexta 07:00 às 17:00'],
	},
	{
		name: '617 L.F PA SANTA ROSA DE VITERBO',
		unitName: 'PA SANTA ROSA DE VITERBO',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'SANTA ROSA DE VITERBO',
		zipCode: '14270-008',
		address: 'RUA DR, R. DR. MARIO CARNEIRO DA CUNHA, 949 - CENTRO',
		workHours: ['Segunda à Sexta 07:00 às 19:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL BARRETOS',
		unitName: 'BARRETOS',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'BARRETOS',
		zipCode: '14780-536',
		address: 'AV. QUARENTA E TRÊS, 780 - JARDIM ALVORADA',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  S JOSE RIO PRETO',
		unitName: 'S JOSE RIO PRETO',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'SAO JOSE DO RIO PRETO',
		zipCode: '15090-275',
		address: 'AVENIDA JOSÉ MUNIA, 6250 - JD. FRANCISCO FERNANDES',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  FRANCA',
		unitName: 'FRANCA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'FRANCA',
		zipCode: '1400-8200',
		address: 'RUA DR. FERNANDO FALLEIROS DE LIMA, 2233 - SÃO JOSÉ (ANEXO AO HOSPITAL)',
		workHours: ['Segunda à Sexta 07:30 às 17:00'],
	},
	{
		name: '734 L.F PA ORLANDIA',
		unitName: 'PA ORLANDIA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'ORLANDIA',
		zipCode: '14670-005',
		address: 'RUA: 18, 565 -  CENTRO',
		workHours: ['Segunda à Sexta 07:00 às 18:00'],
	},
	{
		name: '737 L.F CLINICA MORRO AGUDO',
		unitName: 'CLINICA MORRO AGUDO',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'MORRO AGUDO',
		zipCode: '14640-000',
		address: 'RUA SEBASTIÃO MUNIZ, 133 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '741 L.F CLINICA NUPORANGA',
		unitName: 'CLINICA NUPORANGA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'NUPORANGA',
		zipCode: '14670-057',
		address: 'RUA ESPIRITO SANTO 499 - CENTRO',
		workHours: ['Segunda à Quinta 08:00 às 18:00', 'Sexta 08:00 às 17:00'],
	},
	{
		name: '742 L.F CLINICA NOVO HORIZONTE',
		unitName: 'CLINICA NOVO HORIZONTE',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'NOVO HORIZONTE',
		zipCode: '14960-154',
		address: 'R. VINTE E OITO DE OUTUBRO, 1249 - VILA PATTI',
		workHours: ['Segunda à Sexta 07:00 às 17:00'],
	},
	{
		name: '744 L.F CLINICA MARILIA',
		unitName: 'CLINICA MARILIA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'MARILIA',
		zipCode: '17507-000',
		address: 'AVENIDA CASTRO ALVES, N. 1717 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL   SÃO JOSÉ DOS CAMPOS',
		unitName: 'SÃO JOSÉ - SÃO JOSÉ DOS CAMPOS',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'SAO JOSE DOS CAMPOS',
		zipCode: '12245-360',
		address: 'PRAÇA MELVIN JONES, 7 - JARDIM SÃO DIMAS',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  LIMEIRA',
		unitName: 'MEDICAL - LIMEIRA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'LIMEIRA',
		zipCode: '13480-756',
		address: 'R. TRAJANO DE BARROS CAMARGO, 1531 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '243 L.F IRACEMÁPOLIS',
		unitName: 'IRACEMÁPOLIS - LIMERIA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'LIMEIRA',
		zipCode: '13480-211',
		address: 'R. DUQUE DE CAXIAS, 222 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 16:30'],
	},
	{
		name: '566 L.F MARIA MENDES',
		unitName: 'MARIA MENDES(AMÉ. BRASILIENSE)',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'AMERICO BRASILIENSE',
		zipCode: '14820-000',
		address: 'R. MARIA MENDES, 69 - VILA CERQUEIRA',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL ARARAQUARA',
		unitName: 'ARARAQUARA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'ARARAQUARA',
		zipCode: '14801-290',
		address: 'R. GONÇALVES DIAS, 543 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '583 L.F PA SÃO CARLOS',
		unitName: 'PA SÃO CARLOS',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'SAO CARLOS',
		zipCode: '13561-060',
		address: 'R. PAULINO BOTELHO DE ABREU SAMPAIO, 800 - JARDIM BETHANIA',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '586 L.F PA BARRA BONITA',
		unitName: 'PA BARRA BONITA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'BARRA BONITA',
		zipCode: '17340-000',
		address: 'R. MANOEL D ALMEIDA CAMARGO, 135 - VILA OPERARIA',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '587 L.F CLINICA IBATE',
		unitName: 'CLINICA IBATE',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'IBATE',
		zipCode: '14815-000',
		address: 'AV. SÃO JOÃO, 795 - JARDIM MARIANA',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '593 L.F CLINICA CAPIVARI',
		unitName: 'CLINICA CAPIVARI',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'CAPIVARI',
		zipCode: '13360-000',
		address: 'AV. BRG. FARIA LIMA, 40 - VILA FATIMA',
		workHours: ['Segunda à Sexta 08:00 às 15:40'],
	},
	{
		name: '594 L.F PA LEME',
		unitName: 'PA LEME',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'LEME',
		zipCode: '13617-646',
		address: 'AV. DR. JAMBEIRO COSTA, 850 - CENTRO',
		workHours: ['Segunda à Sexta 07:00 às 19:00'],
	},
	{
		name: '595 L.F CLINICA PIRASSUNUNGA',
		unitName: 'CLINICA PIRASSUNUNGA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'PIRASSUNUNGA',
		zipCode: '13630-140',
		address: 'RUA SIQUEIRA CAMPOS 3993 - JARDIM SANTA RITA',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '613 L.F CLINICA LUIS ANTONIO',
		unitName: 'CLINICA LUIS ANTONIO',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'LUIS ANTONIO',
		zipCode: '14210-000',
		address: 'R. AMÉRICO DE ARAÚJO PÍRES, 182 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '726 L.F PA DESCALVADO',
		unitName: 'PA DESCALVADO',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'DESCALVADO',
		zipCode: '13690-000',
		address: 'R. CONSELHEIRO ANTÔNIO PRADO, 159 - CENTRO',
		workHours: ['Segunda à Sexta 07:00 às 19:00'],
	},
	{
		name: '727 L.F CLINICA VARGEM G DO SUL',
		unitName: 'CLINICA VARGEM G DO SUL',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'VARGEM GRANDE DO SUL',
		zipCode: '13880-000',
		address: 'PRAÇA NOSSA SRA. APARECIDA, 61 - JARDIM PARAISO I',
		workHours: ['Segunda à Sexta 07:00 às 17:00'],
	},
	{
		name: '728 L.F CLINICA TAMBAU',
		unitName: 'CLINICA TAMBAU',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'TAMBAU',
		zipCode: '13710-000',
		address: 'R. CEL. MANOEL S MEIRELES, 20 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '729 L.F PA PORTO FERREIRA',
		unitName: 'PA PORTO FERREIRA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'PORTO FERREIRA',
		zipCode: '13660-000',
		address: 'R. BENTO JOSÉ DE CARVALHO, 315 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '730 L.F CLINICA STA CRUZ PALMEIRAS',
		unitName: 'CLINICA STA CRUZ PALMEIRAS',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'SANTA CRUZ DAS PALMEIRAS',
		zipCode: '13650-000',
		address: 'R. DR. ALCEBÍADES, 136 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '731 L.F CLINICA GUARIBA',
		unitName: 'CLINICA GUARIBA',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'GUARIBA',
		zipCode: '14840-000',
		address: 'R. NELO PETRINE, 1740 - ALTOS DO JARDIM BOA VISTA',
		workHours: ['Segunda à Sexta 07:00 às 18:00'],
	},
	{
		name: '732 L.F PA VIRADOURO',
		unitName: 'PA VIRADOURO',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'VIRADOURO',
		zipCode: '14740-000',
		address: 'R. DO HOSPITAL, 53 - CENTRO',
		workHours: ['Segunda à Sexta 07:00 às 17:00'],
	},
	{
		name: '733 L.F PA PITANGUEIRAS',
		unitName: 'PA PITANGUEIRAS',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'PITANGUEIRAS',
		zipCode: '14750-000',
		address: 'AV. ACRE, 139 - JARDIM BRASILIA',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '735 L.F CLINICA PRADOPOLIS',
		unitName: 'CLINICA PRADOPOLIS',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'PRADOPOLIS',
		zipCode: '14850-000',
		address: 'R. CORONEL JUNQUEIRA, 1095 - CENTRO',
		workHours: ['Segunda à Sexta 07:00 às 17:00'],
	},
	{
		name: '736 L.F PA JABOTICABAL',
		unitName: 'PA JABOTICABAL',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'JABOTICABAL',
		zipCode: '14887-042',
		address: 'R. DR MÁRIO DE CAMPOS, 711 - JARDIM SÃO MARCOS',
		workHours: ['Segunda à Sexta 08:00 às 16:30'],
	},
	{
		name: '739 L.F HOSPITAL NETTO CAMPELLO',
		unitName: 'HOSPITAL NETTO CAMPELLO',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'SERTAOZINHO',
		zipCode: '14160-620',
		address: 'R. ELPÍDIO GOMES, 785 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: '932 L.F SANTA RITA DO PASSA QUATRO',
		unitName: 'SANTA RITA DO PASSA QUATRO',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'SANTA RITA DO PASSA QUATRO',
		zipCode: '13670-000',
		address: 'R. INÁCIO RIBEIRO, 423 - CENTRO',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  PIRACICABA',
		unitName: 'PRUDENTE DE MORAES',
		uf: 'SP',
		estate: 'SAO PAULO',
		city: 'PIRACICABA',
		zipCode: '13400-315',
		address: 'RUA PRUDENTE DE MORAES, 670',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL FORTALEZA',
		unitName: 'HER.GRAÇA',
		uf: 'CE',
		estate: 'CEARA',
		city: 'FORTALEZA',
		zipCode: '60140-060',
		address: 'AV. HERÁCLITO GRAÇA, 406 - CENTRO',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  JUAZEIRO DO NORTE',
		unitName: 'JUAZEIRO',
		uf: 'CE',
		estate: 'CEARA',
		city: 'JUAZEIRO DO NORTE',
		zipCode: '63024-010',
		address: 'AV. PADRE CICERO, 3996 - SÃO JOSÉ',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  MARACANAU',
		unitName: 'MARACANAU',
		uf: 'CE',
		estate: 'CEARA',
		city: 'MARACANAU',
		zipCode: '61939-150',
		address: 'AV. PARQUE COMERCIAL - DISTRITO INDUSTRIAL',
		workHours: ['Segunda à Quinta 07:00 às 17:00', 'Sexta 07:00 às 16:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  JOINVILLE',
		unitName: 'JOINVILLE',
		uf: 'SC',
		estate: 'SANTA CATARINA',
		city: 'JOINVILLE',
		zipCode: '89204-310',
		address: 'RUA BLUMENAU, 1215 - AMÉRICA',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  UBERLANDIA',
		unitName: 'AUT - UBERLANDIA',
		uf: 'MG',
		estate: 'MINAS GERAIS',
		city: 'UBERLANDIA',
		zipCode: '38400-212',
		address: 'R. MARECHAL DEODORO, 11 - CENTRO',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL BELO HORIZONTE',
		unitName: 'TIMBIRAS',
		uf: 'MG',
		estate: 'MINAS GERAIS',
		city: 'BELO HORIZONTE',
		zipCode: '30140-062',
		address: 'RUA DOS TIMBIRAS, 3156 - BARRO PRETO',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  UBERABA',
		unitName: 'RN SAÚDE - UBERABA',
		uf: 'MG',
		estate: 'MINAS GERAIS',
		city: 'UBERABA',
		zipCode: '38050-106',
		address: 'AV. SANTA BEATRIZ DA SILVA , 1910 - SANTA MARIA',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  MANAUS',
		unitName: 'JOÃO VALERIO',
		uf: 'AM',
		estate: 'AMAZONAS',
		city: 'MANAUS',
		zipCode: '69053-358',
		address: 'AV. JOÃO VALÉRIO, 123 - SÃO GERALDO',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL SÃO LUÍS',
		unitName: 'SÃO LUIS',
		uf: 'MA',
		estate: 'MARANHAO',
		city: 'SAO LUIS',
		zipCode: '65015-560',
		address: 'AV. KENNEDY, 1620 - FATIMA',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL BELÉM',
		unitName: 'LOMAS VALENTINAS',
		uf: 'PA',
		estate: 'PARA',
		city: 'BELEM',
		zipCode: '66093-180',
		address: 'TV. MAURITI, 2712 - TELÉGRAFO',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL PARAUAPEBAS',
		unitName: 'PARAUAPEBAS',
		uf: 'PA',
		estate: 'PARA',
		city: 'PARAUAPEBAS',
		zipCode: '68515-000',
		address: 'R. RIO BRANCO, 158 - BEIRA RIO',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL TERESINA',
		unitName: 'TERESINA',
		uf: 'PI',
		estate: 'PIAUI',
		city: 'TERESINA',
		zipCode: '64000-120',
		address: 'R. ELISEU MARTINS, 1672 - CENTRO (SUL)',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  BRASILIA',
		unitName: 'BRASILIA',
		uf: 'DF',
		estate: 'BRASILIA',
		city: 'BRASILIA',
		zipCode: '70340-906',
		address: 'ST SRTVS QD 701 CENTRO EMPRESARIAL ASSIS CHATEAUBRIAND, 2°TERREO, ASA SUL',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL GOIANIA',
		unitName: 'AMÉRICA - GOIANIA',
		uf: 'GO',
		estate: 'GOIAS',
		city: 'GOIANIA',
		zipCode: '74255-220',
		address: 'AV. T9, 1910 - JARDIM AMERICA',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL ANAPOLIS',
		unitName: 'AMÉRICA - ANAPOLIS',
		uf: 'GO',
		estate: 'GOIAS',
		city: 'ANAPOLIS',
		zipCode: '75020-010',
		address: 'AV. SENADOR LOURENÇO DIAS, 631 - CENTRO',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  TRES LAGOAS',
		unitName: 'TRES LAGOAS',
		uf: 'MS',
		estate: 'MATO GROSSO DO SUL',
		city: 'TRES LAGOAS',
		zipCode: '79.601-091',
		address: 'AVENIDA CAPITÃO OLINTO MANCINI, 2560, BAIRRO: JARDIM PRIMAVERIL',
		workHours: ['Segunda à Quinta 07:00 às 17:30', 'Sexta 07:00 às 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  CUIABA',
		unitName: 'CUIABÁ',
		uf: 'MT',
		estate: 'MATO GROSSO',
		city: 'CUIABA',
		zipCode: '78050-010',
		address: 'AV. HISTORIADOR RUBENS DE MENDONÇA, 1856 - BOSQUE DA SAUDE',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL RONDONOPOLIS',
		unitName: 'RONDONÓPOLIS',
		uf: 'MT',
		estate: 'MATO GROSSO',
		city: 'RONDONOPOLIS',
		zipCode: '78705-600',
		address: 'R. FERNANDO CORRÊA DA COSTA, 1538 - VILA MARINOPOLIS',
		workHours: ['Segunda à Sexta 08:00 às 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  UBERLANDIA',
		unitName: '',
		uf: 'MG',
		estate: 'MINAS GERAIS',
		city: 'UBERLANDIA',
		zipCode: '38400-238',
		address: 'RUA VIRGILIO DE MELO FRANCO 465, TAVAJARAS',
		workHours: ['Segunda à Quinta 07:30 às 17:30', 'Sexta até 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL MOSSORÓ',
		unitName: '',
		uf: 'RN',
		estate: 'RIO GRANDE DO NORTE',
		city: 'MOSSORO',
		zipCode: '59600-475',
		address: 'AVENIDA ALBERTO MARANHÃO 1505 - SALA 68, CENTRO',
		workHours: ['Segunda à Quinta 07:30 às 17:30', 'Sexta até 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  UBERABA',
		unitName: '',
		uf: 'MG',
		estate: 'MINAS GERAIS',
		city: 'UBERABA',
		zipCode: '38020-310',
		address: 'RUA ITUIUTABA 577 - ANEXO N 555, SÃO BENEDITO',
		workHours: ['Segunda à Quinta 07:30 às 17:30', 'Sexta até 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL NATAL',
		unitName: '',
		uf: 'RN',
		estate: 'RIO GRANDE DO NORTE',
		city: 'NATAL',
		zipCode: '59072-740',
		address: 'RUA FELIPE CAMARÃO 417, CENTRO',
		workHours: ['Segunda à Quinta 07:00 às 18:30', 'Sexta até 17:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL ARACAJU',
		unitName: '',
		uf: 'SE',
		estate: 'SERGIPE',
		city: 'ARACAJU',
		zipCode: '49015-460',
		address: 'RUA CAMPOS DO BRITO 1180, SÃO JOSE',
		workHours: ['Segunda à Quinta 08:00 às 18:00', 'Sexta até 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL GOIANIA',
		unitName: '',
		uf: 'GO',
		estate: 'GOIAS',
		city: 'GOIANIA',
		zipCode: '74335-102',
		address: 'AVENIDA T63 QUADRA 589, LOTE 2 N 1921',
		workHours: ['Segunda à Quinta 07:30 às 17:30', 'Sexta até 16:30'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL BELÉM',
		unitName: '',
		uf: 'PA',
		estate: 'PARA',
		city: 'BELEM',
		zipCode: '66093-671',
		address: 'TRAVESSA LOMES VALENTINA 1176, PEDREIRA',
		workHours: ['Segunda à Quinta 08:00 às 18:00', 'Sexta até 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL  MANAUS',
		unitName: '',
		uf: 'AM',
		estate: 'AMAZONAS',
		city: 'MANAUS',
		zipCode: '69053-358',
		address: 'AVENIDA JOAO VALERIO 606, NOSSA SRA. DAS GRAÇAS',
		workHours: ['Segunda à Quinta 07:00 às 18:00', 'Sexta até 17:00'],
	},
	{
		name: 'ATENDIMENTO PRESENCIAL SÃO LUÍS',
		unitName: '',
		uf: 'MA',
		estate: 'MARANHAO',
		city: 'SAO LUIS',
		zipCode: '65015-080',
		address: 'AV GUAXENDUBA 260, CENTRO',
		workHours: ['Segunda à Quinta 08:00 às 18:00', 'Sexta até 17:00'],
	},
];

export {ccgUnits, hapUnits, clinipamUnits, gndiminasUnits, gndiUnits};
